import React from "react";

const SummaryPage = ({ token, title }) => {
    return (
        <React.Fragment>
            <h2>You did it! We’ve got your application to the Performance Marketing Diamonds CEE 2021. </h2>
            <p>
                The application will be considered by the Jury after paying the fee for the invoice. We will contact you
                within a few hours.
            </p>
            <p>
                If you have any questions - please contact:&nbsp;
                <a href="mailto:wspolpraca@eizba.pl">wspolpraca@eizba.pl</a>
            </p>

            <p>
                Have a nice day!
                <br />
                e-Chamber of Digital Economy Team
            </p>
            {token && (
                <p>
                    Application number: <strong>{token}</strong>
                </p>
            )}
        </React.Fragment>
    );
};

export default SummaryPage;
